export class PickingQueueDto {
  gendocHdrGuids: string[];
}